import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Menu/Navbar';
import OTPDialog from './Registration/OTPDialog';
import ForgotPasswordComponent from './ForgotPasswordComponent';
import UpdatePassword from './UpdatePassword';
import { ROUTE_HOME, SESSION_USER_ID_KEY } from '../Util/VMConstants';
import StorageFactory from '../Util/StorageFactory';
import { VM_Colors } from '../Styles/VMStyles';

function ForgotPassword() {
  const [showOtpDialog, setShowOtpDialog] = useState(false);
  const [userID, setUserID] = useState('');
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const sessionFactory = new StorageFactory('session');
    if (sessionFactory.has(SESSION_USER_ID_KEY)) {
      navigate('/' + ROUTE_HOME, { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
  if (isOTPVerified && showOtpDialog) {
    setShowOtpDialog(false);
  }
}, [isOTPVerified, showOtpDialog]);

  return (
    <Box sx={{ width: '100%', height: '100vh', bgcolor: '#FFFFFF', overflow: 'auto' }}>
      <Navbar
        position="fixed"
        sx={{
          top: 0,
          zIndex: (theme) => theme.zIndex.drawer + 2,
          backgroundColor: VM_Colors.white,
          boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        }}
      />

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: '100vh', px: 3, pt: 0 }}
        spacing={4}
      >
        {/* Left Image Section */}
        <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box component="img" src={'/static/forgot_password_img.svg'} alt="Forgot password" sx={{ maxWidth: '100%', height: 'auto', maxHeight: 500 }} />
        </Grid>

        {/* Form Section */}
        <Grid item xs={12} md={6}>
       
            {isOTPVerified ? (
              <UpdatePassword userID={userID} mode="create" />
             ) : (
              <ForgotPasswordComponent
                handleClose={(val) => setShowOtpDialog(val)}
                updateUserID={(val) => setUserID(val)}
              />
            )} 

            <OTPDialog
              showOtpDialog={showOtpDialog}
              handleClose={() => setShowOtpDialog(false)}
              arrived="forgotpassword"
              user_id={userID}
              handleOTPVerify={(val) => setIsOTPVerified(val)}
            />

        </Grid>
      </Grid>
    </Box>
  );
}

export default ForgotPassword;
